import { KeyboardArrowDown, KeyboardArrowRight } from '@mui/icons-material'
import { Box, IconButton, Typography } from '@mui/material'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { CgCornerLeftUp } from 'react-icons/cg'
import { DynamicTextTypography } from 'src/components/DynamicTextTypography'
import { IVesselDisplayRow } from './vesselSuccession'

export const VesselNameCell: FC<{ row: IVesselDisplayRow; onToggle: (rootId: number) => void }> = ({
  row,
  onToggle,
}) => {
  const { t: translate } = useTranslation(['task'])

  return (
    <Box display="flex" alignItems="center" gap={0.5} minWidth={0}>
      {row.isHead && row.hasHistory && (
        <IconButton
          size="small"
          aria-label={translate(row.expanded ? 'collapse-succession' : 'expand-succession', { ns: 'task' })}
          aria-expanded={row.expanded}
          onClick={event => {
            event.stopPropagation()
            onToggle(row.rootId)
          }}
        >
          {row.expanded ? <KeyboardArrowDown fontSize="small" /> : <KeyboardArrowRight fontSize="small" />}
        </IconButton>
      )}
      {row.isReplaced && (
        <Box
          component="span"
          display="flex"
          alignItems="center"
          color="text.secondary"
          pl={3}
          aria-label={translate('replaced-vessel', { ns: 'task' })}
          role="img"
        >
          <CgCornerLeftUp size={16} />
        </Box>
      )}
      <Box minWidth={0}>
        <DynamicTextTypography text={row.name} maxLength={20} variant="body1" fontWeight={500} />
        {row.chain && (
          <Typography variant="caption" color="text.secondary" display="block" noWrap title={row.chain}>
            {row.chain}
          </Typography>
        )}
      </Box>
    </Box>
  )
}
